import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {StatusPage} from "@/lib/types/statuspages.ts";
import {
  SUBSCRIBERS_SETTINGS_FORM_ID,
  SubscribersSettingsForm,
} from "@/pages/statuspages/tabs/subscribers/components/SubscribersSettingsForm/SubscribersSettingsForm.tsx";

interface SubscriptionSettingsModalProps {
  show: boolean;
  onClose: () => void;
  statusPage: StatusPage;
}

export const SubscriptionSettingsModal = ({show, onClose, statusPage}: SubscriptionSettingsModalProps) => {
  return (
    <FormModal
      show={show}
      title={"Subscription Settings"}
      formId={SUBSCRIBERS_SETTINGS_FORM_ID}
      onCancel={onClose}
      size={"lg"}
      submitBtnText={"Save"}
      cancelBtnText={"Cancel"}
    >
      <SubscribersSettingsForm statusPage={statusPage} formId={SUBSCRIBERS_SETTINGS_FORM_ID} onSuccess={onClose} />
    </FormModal>
  );
};
